import React from "react";
import TableHeader from "./tableHeader";
import TableBody from "./tableBody";

const Table = ({ columns, data, sortColumn, onSort, fullClass, extraClass }) => {
  let tableClass = "";
  if (fullClass) tableClass = fullClass;
  else tableClass = "table table-bordered table-striped table-hover dataTable dtr-inline";
  if (extraClass) tableClass += " " + extraClass;
  return (
    <div className="row">
      <div className="col-sm-12">
        <table
          id="datatable"
          // className={
          //   fullClass
          //     ? fullClass
          //     : "table table-bordered table-striped table-hover dataTable dtr-inline " + extraClass
          //       ? extraClass
          //       : ""
          // }
          className={tableClass}
          role="grid"
          aria-describedby="datatable_info"
        >
          <TableHeader columns={columns} sortColumn={sortColumn} onSort={onSort} />
          <TableBody data={data} columns={columns} />
        </table>
      </div>
    </div>
  );
};

export default Table;
